// extracted by mini-css-extract-plugin
export default {"video":"oASVC","curriculum":"lXI6I"};